import TextField from "@mui/material/TextField";
import { useEffect, useState, useRef } from "react";
import { ListBodyItemActionPreference } from "../../../../components/_widgets/WidgetsList";

const EachPreference = ({
  option,
  addButton,
  index,
  descriptions,
  updateDescriptions,
  handleDelete,
  moveDown,
  moveUp,
  element,
}) => {
  const [value, setValue] = useState(option);
  const myRef = useRef(element._id + index);

  useEffect(() => {
    setValue(option);
  }, [option]);

  const handleChangeValue = (value) => {
    setValue(value);
    descriptions.splice(index, 1, value);
    updateDescriptions(descriptions);
  };

  return (
    <>
      <TextField
        ref={myRef}
        className="col-lg-4"
        label="Nome do campo"
        value={value}
        defaultValue=""
        onChange={(e) => handleChangeValue(e.target.value)}
      />
      <span
        className="c-blue-link preference-card-link t-decoration-none c-pointer ms-2 me-auto"
        onClick={() => handleChangeValue(value)}
      >
        Salvar
      </span>
      <span
        className="c-blue-link preference-card-link t-decoration-none c-pointer ms-5 me-auto"
        onClick={() => addButton(index, myRef)}
      >
        + Adicionar novo campo
      </span>
      <ListBodyItemActionPreference>
        <li className="p-4-16 dropdown-item">
          <span className="fz-14 ff-univanova-regular c-pointer c-black-preference" onClick={() => moveUp(index)}>
            Mover para cima
          </span>
        </li>
        <li className="p-4-16 dropdown-item">
          <span className="fz-14 ff-univanova-regular c-pointer c-black-preference" onClick={() => moveDown(index)}>
            Mover para baixo
          </span>
        </li>
        <li className="p-4-16 dropdown-item">
          <span
            className="fz-14 ff-univanova-regular c-black-preference c-pointer text-cl-red"
            onClick={() => handleDelete(index)}
          >
            Excluir
          </span>
        </li>
      </ListBodyItemActionPreference>
    </>
  );
};
export default EachPreference;
